module.exports = __webpack_public_path__ + "img/82a72eeb2dda819aa67b5a5c4b8ac79c.png";